import RedeemIcon from '@mui/icons-material/Redeem';
import DomainVerificationIcon from '@mui/icons-material/DomainVerification';

export const OTHER = 'Other';
export const other = 'other';

export const QUESTIONS = 'Questions';
export const SELECTIONS = 'Selections';
export const TYPE = 'type';

export const OPEN = 'Open';
export const NEXT = 'NEXT';

export const THANK_YOU_MESSAGE = 'Thank you so much!';

export const SINGLE_SELECT = 'Single Select';
export const MULTI_SELECT = 'Multi Select';
export const OPEN_ENDED = 'OPEN_ENDED';
export const MORE_SELECTIONS = 'MORE_SELECTIONS';
export const OPEN_ENDED_INPUT = 'OPEN_ENDED_INPUT';

export const WHAT_AGE_GROUP_ARE_YOU = 'What age group are you?';
export const WHAT_IS_YOUR_OCCUPATION = 'What is your occupation?';
export const HOW_IMPORTANT_IS_BRAND_RECOGNITION =
  'How important is Brand Recognition? (1 to 5 - 5 Most Important)';

export const ANY_VETERANS = 'Any family member veterans?';

export const NO_IMPORTANCE = '1';
export const LITTLE_IMPORTANCE = '2';
export const IMPORTANT = '3';
export const VERY_IMPORTANT = '4';
export const MOST_IMPORTANT = '5';

export const VALUE = 'VALUE';
export const NA = 'NA';

export const moreInfo = 'moreInfo';

export const NEVER = 'Never';
export const SOMETIMES = 'Sometimes';
export const FREQUENTLY = 'Frequently';
export const ALWAYS = 'Always';

export const BRAND_NAME_RECOGNITION_OPTIONS = {
  [TYPE]: SINGLE_SELECT,
  [SELECTIONS]: {
    A: {
      text: NO_IMPORTANCE,
      value: NO_IMPORTANCE,
    },
    B: {
      text: LITTLE_IMPORTANCE,
      value: LITTLE_IMPORTANCE,
    },
    C: {
      text: IMPORTANT,
      value: IMPORTANT,
    },
    D: {
      text: VERY_IMPORTANT,
      value: VERY_IMPORTANT,
    },
    E: {
      text: MOST_IMPORTANT,
      value: MOST_IMPORTANT,
    },
  },
};

export const RATE_UI_SELECTION_OPTIONS = {
  [TYPE]: SINGLE_SELECT,
  [SELECTIONS]: {
    A: {
      text: NO_IMPORTANCE,
      value: NO_IMPORTANCE,
    },
    B: {
      text: LITTLE_IMPORTANCE,
      value: LITTLE_IMPORTANCE,
    },
    C: {
      text: IMPORTANT,
      value: IMPORTANT,
    },
    D: {
      text: VERY_IMPORTANT,
      value: VERY_IMPORTANT,
    },
    E: {
      text: NA,
      value: NA,
    },
  },
};

export const UNDER_25 = '< 25';
export const UNDER_35 = '< 35';
export const UNDER_45 = '< 45';
export const UNDER_55 = '< 55';
export const OVER_54 = '55+';

export const STUDENT = 'Student';
export const student = 'student';

export const TECHNOLOGY = 'Tech';
export const technology = 'tech';

export const ENGINEER_AND_LEADERSHIP =
  'Software Engineer, Mechanical Engineer, Electrical Engineer, or Tech Leadership';
export const engineer_and_leadership = 'engineer_and_leadership';

export const SALES_AND_SERVICE = 'Sales, Marketing, Digital Content and Customer Success';
export const sales_and_service = 'sales_and_service';

export const FINANCE_AND_REVENUE = 'Tech Finance or Revenue Operations';
export const finance_and_revenue = 'finance_and_revenue';

export const PRODUCT_MANAGEMENT = 'Product Management';
export const product_management = 'product_management';

export const MEDICINE = 'Healthcare';
export const medicine = 'healthcare';

export const RETAIL_SERVICE_WORKER = 'Retail';
export const retail_service_worker = 'retail';

export const LAW = 'Law';
export const law = 'law';

export const INSURANCE = 'Insurance';
export const insurance = 'insurance';

export const FINANCE = 'Finance';
export const finance = 'finance';

export const TEACHER = 'Teacher';
export const teacher = 'teacher';

export const PROFESSOR = 'Professor';
export const professor = 'professor';

export const MORTGAGE_LOANS = 'Mortgage Loans';
export const MORTGAGE_LOANS_VALUE = 'mortgage_loans';

export const AUTO_LOANS = 'Auto Loans';
export const AUTO_LOANS_VALUE = 'auto_loans';

export const AUTO_INSURANCE = 'Auto Insurance';
export const AUTO_INSURANCE_VALUE = 'auto_insurance';

export const HOME_INSURANCE = 'Homeowners Insurance';
export const HOME_INSURANCE_VALUE = 'homeowners_insurance';

export const SPOUSE = 'Spouse';
export const SELF = 'Self';
export const CHILD = 'Child';
export const PARENT = 'Parent';
export const NONE = 'None';

export const PRODUCT_SERVICE_TYPES = {
  [MORTGAGE_LOANS]: MORTGAGE_LOANS,
  [AUTO_LOANS]: AUTO_LOANS,
  [AUTO_INSURANCE]: AUTO_INSURANCE,
  [HOME_INSURANCE]: HOME_INSURANCE,
};

export const NECESSARY_GENERAL_QUESTIONS = {
  [QUESTIONS]: {
    [WHAT_AGE_GROUP_ARE_YOU]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: UNDER_25,
          value: 24,
        },
        B: {
          text: UNDER_35,
          value: 34,
        },
        C: {
          text: UNDER_45,
          value: 44,
        },
        D: {
          text: UNDER_55,
          value: 54,
        },
        E: {
          text: OVER_54,
          value: 55,
        },
      },
    },
    [WHAT_IS_YOUR_OCCUPATION]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: STUDENT,
          value: student,
        },
        B: {
          text: TECHNOLOGY,
          value: technology,
          moreInfo: {
            [TYPE]: SINGLE_SELECT,
            [SELECTIONS]: {
              A: {
                text: ENGINEER_AND_LEADERSHIP,
                value: engineer_and_leadership,
              },
              B: {
                text: SALES_AND_SERVICE,
                value: sales_and_service,
              },
              C: {
                text: FINANCE_AND_REVENUE,
                value: finance_and_revenue,
              },
              D: {
                text: PRODUCT_MANAGEMENT,
                value: product_management,
              },
            },
          },
        },
        C: {
          text: MEDICINE,
          value: medicine,
        },
        D: {
          text: RETAIL_SERVICE_WORKER,
          value: retail_service_worker,
        },
        E: {
          text: LAW,
          value: law,
        },
        F: {
          text: OTHER,
          value: other,
        },
      },
    },
    [HOW_IMPORTANT_IS_BRAND_RECOGNITION]: {
      [TYPE]: NONE,
    },
    [MORTGAGE_LOANS]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: NO_IMPORTANCE,
          value: NO_IMPORTANCE,
        },
        B: {
          text: LITTLE_IMPORTANCE,
          value: LITTLE_IMPORTANCE,
        },
        C: {
          text: IMPORTANT,
          value: IMPORTANT,
        },
        D: {
          text: VERY_IMPORTANT,
          value: VERY_IMPORTANT,
        },
        E: {
          text: MOST_IMPORTANT,
          value: MOST_IMPORTANT,
        },
      },
    },
    [AUTO_LOANS]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: NO_IMPORTANCE,
          value: NO_IMPORTANCE,
        },
        B: {
          text: LITTLE_IMPORTANCE,
          value: LITTLE_IMPORTANCE,
        },
        C: {
          text: IMPORTANT,
          value: IMPORTANT,
        },
        D: {
          text: VERY_IMPORTANT,
          value: VERY_IMPORTANT,
        },
        E: {
          text: MOST_IMPORTANT,
          value: MOST_IMPORTANT,
        },
      },
    },
    [AUTO_INSURANCE]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: NO_IMPORTANCE,
          value: NO_IMPORTANCE,
        },
        B: {
          text: LITTLE_IMPORTANCE,
          value: LITTLE_IMPORTANCE,
        },
        C: {
          text: IMPORTANT,
          value: IMPORTANT,
        },
        D: {
          text: VERY_IMPORTANT,
          value: VERY_IMPORTANT,
        },
        E: {
          text: MOST_IMPORTANT,
          value: MOST_IMPORTANT,
        },
      },
    },
    [HOME_INSURANCE]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: NO_IMPORTANCE,
          value: NO_IMPORTANCE,
        },
        B: {
          text: LITTLE_IMPORTANCE,
          value: LITTLE_IMPORTANCE,
        },
        C: {
          text: IMPORTANT,
          value: IMPORTANT,
        },
        D: {
          text: VERY_IMPORTANT,
          value: VERY_IMPORTANT,
        },
        E: {
          text: MOST_IMPORTANT,
          value: MOST_IMPORTANT,
        },
      },
    },
    [ANY_VETERANS]: {
      [TYPE]: MULTI_SELECT,
      [SELECTIONS]: {
        A: {
          text: SPOUSE,
          value: SPOUSE,
        },
        B: {
          text: SELF,
          value: SELF,
        },
        C: {
          text: CHILD,
          value: CHILD,
        },
        E: {
          text: PARENT,
          value: PARENT,
        },
        F: {
          text: NONE,
          value: NONE,
        },
        G: {
          text: NA,
          value: NA,
        },
      },
    },
  },
};

export const CONSUMER_NEEDS_IN_GENERAL =
  'Among your consumer needs in general, what is the biggest problem that you would love solved?';

export const PREDICTIVE_DATA_MODELING =
  'Would you like to learn more about our Predictive Financing Data Modeling?';

export const MARKETPLACE_PLATFORM =
  'Which one of the current marketplace platform do you currently use?';

export const ASPECTS_STOOD_OUT = 'What aspects of CashClever stood out to you?';

export const SPEAK_WITH_FOUNDER = 'Would you like to speak with the Founder?';

export const YES = 'Yes';
export const yes = 'yes';

export const NO = 'No';
export const no = 'no';

export const MAYBE = 'Maybe';
export const maybe = 'maybe';

export const SPEAK_WITH_FOUNDER_LEARN_MORE = 'Speak with Founder';
export const SPEAK_WITH_FOUNDER_VALUE = 'Speak with Founder';

export const NerdWallet = 'NerdWallet';

export const Bankrate = 'Bankrate';

export const LendingTree = 'LendingTree';

export const Credible = 'Credible';

export const GENERIC_GENERAL_QUESTIONS = {
  [QUESTIONS]: {
    [CONSUMER_NEEDS_IN_GENERAL]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [PREDICTIVE_DATA_MODELING]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: YES,
          value: yes,
        },
        B: {
          text: NO,
          value: no,
        },
        C: {
          text: MAYBE,
          value: maybe,
        },
      },
    },
    [MARKETPLACE_PLATFORM]: {
      [TYPE]: MULTI_SELECT,
      [SELECTIONS]: {
        A: {
          text: NerdWallet,
          value: NerdWallet,
        },
        B: {
          text: Bankrate,
          value: Bankrate,
        },
        C: {
          text: LendingTree,
          value: LendingTree,
        },
        D: {
          text: Credible,
          value: Credible,
        },
        E: {
          text: OTHER,
          value: other,
        },
      },
    },
    [ASPECTS_STOOD_OUT]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [SPEAK_WITH_FOUNDER]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: YES,
          value: yes,
        },
        B: {
          text: NO,
          value: no,
        },
      },
    },
  },
};

export const GENERAL_QUESTIONS = {
  skipped: false,
  completed: false,
  NECESSARY_GENERAL_QUESTIONS,
  GENERIC_GENERAL_QUESTIONS,
};

export const MOBILE_OR_DESKTOP_VIEW = 'What device do you primarily browse on?';

export const RATE_THE_UI_EXPERIENCE_OF_EACH_LENDER_LISTING =
  'Rate the UI Experience of each of the Lender Listing Marketplace Platforms';

export const RATE_THE_UI_EXPERIENCE_OF_EACH_AUTO_LISTING =
  'Rate the UI Experience of each of the Auto Listing Marketplace Platforms';

export const RATE_THE_UI_EXPERIENCE_OF_EACH_REAL_ESTATE_LISTING =
  'Rate the UI Experience of each of the Real Estate Listing Marketplace Platforms';

export const ANOTHER_LANGUAGE =
  'Do you speak another language other than English as your primary language?';

export const MOBILE = 'Mobile';
export const mobile = 'mobile';

export const DESKTOP = 'Desktop';
export const desktop = 'desktop';

export const IPAD = 'Ipad';
export const ipad = 'ipad';

export const CARGURUS = 'CarGurus';
export const CARVANA = 'Carvana';
export const CARMAX = 'CarMax';
export const EDMUNDS = 'Edmunds';
export const CARSDIRECT = 'CarsDirect';
export const AUTOTRADER = 'AutoTrader';
export const CARFAX = 'CarFax';

export const ZILLOW = 'Zillow';
export const REDFIN = 'RedFin';
export const COMPASS = 'Compass';
export const REALTOR = 'Realtor.com';

export const PARTNERS = {
  [NerdWallet]: NerdWallet,
  [Bankrate]: Bankrate,
  [LendingTree]: LendingTree,
  [Credible]: Credible,
  [CARGURUS]: CARGURUS,
  [CARVANA]: CARVANA,
  [CARMAX]: CARMAX,
  [EDMUNDS]: EDMUNDS,
  [CARSDIRECT]: CARSDIRECT,
  [AUTOTRADER]: AUTOTRADER,
  [CARFAX]: CARFAX,
  [ZILLOW]: ZILLOW,
  [REDFIN]: REDFIN,
  [COMPASS]: COMPASS,
  [REALTOR]: REALTOR,
};

export const SPANISH = 'Spanish';
export const FRENCH = 'French';
export const CHINESE = 'Chinese';

export const NECESSARY_UI_EXPERIENCE_QUESTIONS = {
  [QUESTIONS]: {
    [MOBILE_OR_DESKTOP_VIEW]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: MOBILE,
          value: mobile,
        },
        B: {
          text: DESKTOP,
          value: desktop,
        },
        C: {
          text: IPAD,
          value: ipad,
        },
      },
    },
    [RATE_THE_UI_EXPERIENCE_OF_EACH_LENDER_LISTING]: {
      [TYPE]: NONE,
    },
    [NerdWallet]: JSON.parse(JSON.stringify(RATE_UI_SELECTION_OPTIONS)),
    [Bankrate]: JSON.parse(JSON.stringify(RATE_UI_SELECTION_OPTIONS)),
    [LendingTree]: JSON.parse(JSON.stringify(RATE_UI_SELECTION_OPTIONS)),
    [Credible]: JSON.parse(JSON.stringify(RATE_UI_SELECTION_OPTIONS)),
    [RATE_THE_UI_EXPERIENCE_OF_EACH_AUTO_LISTING]: {
      [TYPE]: NONE,
    },
    [CARGURUS]: JSON.parse(JSON.stringify(RATE_UI_SELECTION_OPTIONS)),
    [CARVANA]: JSON.parse(JSON.stringify(RATE_UI_SELECTION_OPTIONS)),
    [CARMAX]: JSON.parse(JSON.stringify(RATE_UI_SELECTION_OPTIONS)),
    [EDMUNDS]: JSON.parse(JSON.stringify(RATE_UI_SELECTION_OPTIONS)),
    [CARSDIRECT]: JSON.parse(JSON.stringify(RATE_UI_SELECTION_OPTIONS)),
    [AUTOTRADER]: JSON.parse(JSON.stringify(RATE_UI_SELECTION_OPTIONS)),
    [CARFAX]: JSON.parse(JSON.stringify(RATE_UI_SELECTION_OPTIONS)),
    [RATE_THE_UI_EXPERIENCE_OF_EACH_REAL_ESTATE_LISTING]: {
      [TYPE]: NONE,
    },
    [ZILLOW]: JSON.parse(JSON.stringify(RATE_UI_SELECTION_OPTIONS)),
    [REDFIN]: JSON.parse(JSON.stringify(RATE_UI_SELECTION_OPTIONS)),
    [COMPASS]: JSON.parse(JSON.stringify(RATE_UI_SELECTION_OPTIONS)),
    [REALTOR]: JSON.parse(JSON.stringify(RATE_UI_SELECTION_OPTIONS)),
    [ANOTHER_LANGUAGE]: {
      [TYPE]: MULTI_SELECT,
      [SELECTIONS]: {
        A: {
          text: SPANISH,
          value: SPANISH,
        },
        B: {
          text: FRENCH,
          value: FRENCH,
        },
        C: {
          text: CHINESE,
          value: CHINESE,
        },
        E: {
          text: OTHER,
          value: other,
        },
        F: {
          text: NA,
          value: NA,
        },
      },
    },
  },
};

export const UI_EXPERIENCE_QUESTIONS = {
  skipped: false,
  completed: false,
  NECESSARY_UI_EXPERIENCE_QUESTIONS,
};

export const DREAM_CAR = 'What is your dream car?';
export const IDEAL_CAR = 'What is your ideal car?';
export const VEHICLES_PER_HOUSEHOLD = 'How many vehicles do you have in your household?';
export const IDEAL_VEHICLES_PER_HOUSEHOLD = 'How many vehicles do you intend to have?';
export const CHANGE_VEHICLES = 'How often do you change vehicles?';

export const OFTEN_COMMUTE_TO_WORK = 'How often do you commute to work?';
export const TRANSPORT_TO_WORK = 'How do you commute to work?';
export const PRIMARY_USE_OF_VEHICLE = 'What is your primary use for Auto?';
export const OWN_OR_PLAN_TO_OWN_ELECTRIC = 'Do you own or plan to own an electric vehicle?';

export const PURCHASING_VEHICLE_LOANS_INSURANCE_ONLINE =
  'How do you feel about having the car buying experience with loans and insurance online?';

export const BIGGEST_PAIN_POINT_AUTO =
  'What are the biggest problems you face when you are purchasing auto vehicles?';

export const WFH = 'WFH';

export const ONCE_TO_THREE_PER_WEEK = '1 - 3 / Week';
export const FOUR_TO_FIVE = '4 - 5 / Week';
export const DEPENDS = 'Depends';

export const DRIVE = 'Drive';
export const CARPOOL = 'Carpool';
export const TRAIN_OR_BUS = 'Train / Bus';
export const WALK_OR_BIKE = 'Walk / Bike';

export const LEISURE = 'Leisure';
export const RIDESHARE = 'Rideshare';
export const COMMUTE = 'Commute';
export const ERRANDS = 'Errands';

export const TOO_EXPENSIVE = 'Too Expensive';
export const TOO_CHEAP = 'Too Cheap';

export const EVERY_TEN_YEARS = 'Every 10 Years';
export const EVERY_FIVE_YEARS = 'Every 5 Years';
export const EVERY_THREE_YEARS = 'Every 3 Years';
export const EVERY_YEAR = 'Every Year';

export const GENERAL_AUTO_QUESTIONS = {
  [QUESTIONS]: {
    [DREAM_CAR]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [IDEAL_CAR]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [VEHICLES_PER_HOUSEHOLD]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: 0,
          value: 0,
        },
        B: {
          text: 1,
          value: 1,
        },
        C: {
          text: 2,
          value: 2,
        },
        E: {
          text: 3,
          value: 3,
        },
        F: {
          text: '4+',
          value: 4,
        },
      },
    },
    [IDEAL_VEHICLES_PER_HOUSEHOLD]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: 0,
          value: 0,
        },
        B: {
          text: 1,
          value: 1,
        },
        C: {
          text: 2,
          value: 2,
        },
        E: {
          text: 3,
          value: 3,
        },
        F: {
          text: '4+',
          value: 4,
        },
      },
    },
    [CHANGE_VEHICLES]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: NEVER,
          value: NEVER,
        },
        B: {
          text: EVERY_TEN_YEARS,
          value: EVERY_TEN_YEARS,
        },
        C: {
          text: EVERY_FIVE_YEARS,
          value: EVERY_FIVE_YEARS,
        },
        E: {
          text: EVERY_THREE_YEARS,
          value: EVERY_THREE_YEARS,
        },
        F: {
          text: EVERY_YEAR,
          value: EVERY_YEAR,
        },
      },
    },
    [OFTEN_COMMUTE_TO_WORK]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: WFH,
          value: WFH,
        },
        B: {
          text: ONCE_TO_THREE_PER_WEEK,
          value: ONCE_TO_THREE_PER_WEEK,
        },
        C: {
          text: FOUR_TO_FIVE,
          value: FOUR_TO_FIVE,
        },
        E: {
          text: DEPENDS,
          value: DEPENDS,
        },
        F: {
          text: NA,
          value: NA,
        },
      },
    },
    [TRANSPORT_TO_WORK]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: DRIVE,
          value: DRIVE,
        },
        B: {
          text: CARPOOL,
          value: CARPOOL,
        },
        C: {
          text: TRAIN_OR_BUS,
          value: TRAIN_OR_BUS,
        },
        E: {
          text: WALK_OR_BIKE,
          value: WALK_OR_BIKE,
        },
        F: {
          text: NA,
          value: NA,
        },
      },
    },
    [PRIMARY_USE_OF_VEHICLE]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: LEISURE,
          value: LEISURE,
        },
        B: {
          text: RIDESHARE,
          value: RIDESHARE,
        },
        C: {
          text: COMMUTE,
          value: COMMUTE,
        },
        E: {
          text: ERRANDS,
          value: ERRANDS,
        },
        F: {
          text: NA,
          value: NA,
        },
      },
    },
    [OWN_OR_PLAN_TO_OWN_ELECTRIC]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: YES,
          value: YES,
        },
        B: {
          text: NO,
          value: NO,
        },
        C: {
          text: MAYBE,
          value: MAYBE,
        },
        E: {
          text: TOO_EXPENSIVE,
          value: TOO_EXPENSIVE,
        },
        F: {
          text: TOO_CHEAP,
          value: TOO_CHEAP,
        },
      },
    },
    [PURCHASING_VEHICLE_LOANS_INSURANCE_ONLINE]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [BIGGEST_PAIN_POINT_AUTO]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
  },
};

export const AUTO_SURVEY_QUESTIONS = {
  skipped: false,
  completed: false,
  GENERAL_AUTO_QUESTIONS,
};

export const HOW_MANY_VEHICLES = 'How many vehicles have you financed before?';

export const FINANCE_WITH_CO_BORROWER = 'Did you finance with a co-borrower?';

export const IN_PERSON_OR_ONLINE = 'Did you apply in person or online?';

export const REFINANCE_IN_PERSON_OR_ONLINE = 'Did you refinance in person or online?';

export const DID_SHOPPING_FOR_LOANS_IMPACT_CAR =
  'Did shopping for loans have an impact on the vehicle you purchase?';

export const DECISIONS_BASED_ON_LOANS =
  'How much impact would the loan rates have on vehicle choice?';

export const MOST_IMPORTANT_ASPECT_OF_LOAN =
  'What is the most important aspect of Auto Loans for you?';

export const GAP_INSURANCE = 'Do you consider gap insurance when you are shopping for auto loans?';

export const PROCESS_ONLINE = 'Would you prefer to have the entire auto loans process online?';

export const BIGGEST_PAIN_POINT_AUTO_LOANS =
  'What are the biggest problems you face when you shopping for auto loans?';

export const ONLINE = 'Online';
export const IN_PERSON = 'In Person';

export const BOTH = 'Both';

export const MONTHLY_PAYMENT = 'Mo. Pmt.';

export const APR = 'APR';

export const FLEXIBLE_PAY = 'Flexible Pay';

export const LOAN_TERM = 'Loan Term';

export const GENERAL_AUTO_LOANS_QUESTIONS = {
  [QUESTIONS]: {
    [HOW_MANY_VEHICLES]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: 0,
          value: 0,
        },
        B: {
          text: 1,
          value: 1,
        },
        C: {
          text: 2,
          value: 2,
        },
        D: {
          text: '3+',
          value: 3,
        },
      },
    },
    [FINANCE_WITH_CO_BORROWER]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: YES,
          value: YES,
        },
        B: {
          text: NO,
          value: NO,
        },
      },
    },
    [IN_PERSON_OR_ONLINE]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: ONLINE,
          value: ONLINE,
        },
        B: {
          text: IN_PERSON,
          value: IN_PERSON,
        },
        C: {
          text: BOTH,
          value: BOTH,
        },
        C: {
          text: NA,
          value: NA,
        },
      },
    },
    [REFINANCE_IN_PERSON_OR_ONLINE]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: ONLINE,
          value: ONLINE,
        },
        B: {
          text: IN_PERSON,
          value: IN_PERSON,
        },
        C: {
          text: BOTH,
          value: BOTH,
        },
        D: {
          text: NA,
          value: NA,
        },
      },
    },
    [DID_SHOPPING_FOR_LOANS_IMPACT_CAR]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: YES,
          value: YES,
        },
        B: {
          text: NO,
          value: NO,
        },
        C: {
          text: MAYBE,
          value: MAYBE,
        },
      },
    },
    [DECISIONS_BASED_ON_LOANS]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: NONE,
          value: NONE,
        },
        B: {
          text: '25%',
          value: '25%',
        },
        C: {
          text: '50%',
          value: '50%',
        },
        D: {
          text: '75%',
          value: '75%',
        },
        E: {
          text: '100%',
          value: '100%',
        },
      },
    },
    [MOST_IMPORTANT_ASPECT_OF_LOAN]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: MONTHLY_PAYMENT,
          value: MONTHLY_PAYMENT,
        },
        B: {
          text: APR,
          value: APR,
        },
        C: {
          text: FLEXIBLE_PAY,
          value: FLEXIBLE_PAY,
        },
        D: {
          text: LOAN_TERM,
          value: LOAN_TERM,
        },
        E: {
          text: NA,
          value: NA,
        },
      },
    },
    [GAP_INSURANCE]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: YES,
          value: YES,
        },
        B: {
          text: NO,
          value: NO,
        },
        C: {
          text: SOMETIMES,
          value: SOMETIMES,
        },
        D: {
          text: NEVER,
          value: NEVER,
        },
        E: {
          text: NA,
          value: NA,
        },
      },
    },
    [PROCESS_ONLINE]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: YES,
          value: YES,
        },
        B: {
          text: NO,
          value: NO,
        },
        C: {
          text: SOMETIMES,
          value: SOMETIMES,
        },
        D: {
          text: NEVER,
          value: NEVER,
        },
        E: {
          text: NA,
          value: NA,
        },
      },
    },
    [BIGGEST_PAIN_POINT_AUTO_LOANS]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
  },
};

export const AUTO_LOANS_SURVEY_QUESTIONS = {
  skipped: false,
  completed: false,
  GENERAL_AUTO_LOANS_QUESTIONS,
};

export const SHOP_FOR_AUTO_INSURANCE = 'How often do you shop around for auto insurance?';

export const HOW_DO_YOU_PAY_INSURANCE = 'How do you pay your auto insurance premiums?';

export const HOW_DO_YOU_PAY_CYCLE = 'What payment cycle do you pay your premiums?';

export const COVERAGE_TYPE = 'Which coverage is the most important for you?';

export const AUTO_INSURANCE_PROVIDERS = "Name all auto carriers you've had.";

export const FEEL_ABOUT_INSURANCE_PROCESS_ONLINE =
  'Would you prefer to have the entire auto insurance process online?';

export const FEEL_ABOUT_AI_HANDLING_CLAIMS_PROCESS =
  'How do you feel about the auto claims process being handled by AI in reaching out to parties and accessing liability?';

export const PAIN_POINTS_OF_CLAIMS_EXP =
  'What are the biggest pain points and problems of the current claims experience?';

export const ASPECTS_OF_ADJUSTER_MISS =
  'What aspects of not having a claims adjuster would you miss?';

export const BIGGEST_PAIN_POINTS_AUTO_INSURANCE =
  'What are the biggest pain points and problems of the auto insurance shopping experience?';

export const CHECK = 'Check';
export const NOT_SURE = 'Not Sure';

export const UPFRONT = 'Upfront';
export const MONTHLY = 'Monthly';
export const BI_MONTHLY = 'Bi-Monthly';
export const QUARTERLY = 'Quarterly';
export const SEMI_ANNUALLY = 'Semi-Annually';

export const COLLISION = 'Collision';
export const PROPERTY = 'Property';
export const COMPREHENSIVE = 'Comprehensive';
export const BODILY_INJURY = 'Bodily Injury';
export const PIP = 'PIP';

export const GENERAL_AUTO_INSURANCE_QUESTIONS = {
  [QUESTIONS]: {
    [SHOP_FOR_AUTO_INSURANCE]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: NEVER,
          value: NEVER,
        },
        B: {
          text: SOMETIMES,
          value: SOMETIMES,
        },
        C: {
          text: FREQUENTLY,
          value: FREQUENTLY,
        },
        D: {
          text: ALWAYS,
          value: ALWAYS,
        },
      },
    },
    [HOW_DO_YOU_PAY_INSURANCE]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: ONLINE,
          value: ONLINE,
        },
        B: {
          text: CHECK,
          value: CHECK,
        },
        C: {
          text: IN_PERSON,
          value: IN_PERSON,
        },
        D: {
          text: NOT_SURE,
          value: NOT_SURE,
        },
      },
    },
    [HOW_DO_YOU_PAY_CYCLE]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: UPFRONT,
          value: UPFRONT,
        },
        B: {
          text: MONTHLY,
          value: MONTHLY,
        },
        C: {
          text: BI_MONTHLY,
          value: BI_MONTHLY,
        },
        D: {
          text: QUARTERLY,
          value: QUARTERLY,
        },
        E: {
          text: SEMI_ANNUALLY,
          value: SEMI_ANNUALLY,
        },
        F: {
          text: DEPENDS,
          value: DEPENDS,
        },
      },
    },
    [COVERAGE_TYPE]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: COLLISION,
          value: COLLISION,
        },
        B: {
          text: PROPERTY,
          value: PROPERTY,
        },
        C: {
          text: COMPREHENSIVE,
          value: COMPREHENSIVE,
        },
        D: {
          text: BODILY_INJURY,
          value: BODILY_INJURY,
        },
        E: {
          text: PIP,
          value: PIP,
        },
      },
    },
    [AUTO_INSURANCE_PROVIDERS]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [FEEL_ABOUT_INSURANCE_PROCESS_ONLINE]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [FEEL_ABOUT_AI_HANDLING_CLAIMS_PROCESS]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [PAIN_POINTS_OF_CLAIMS_EXP]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [ASPECTS_OF_ADJUSTER_MISS]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [BIGGEST_PAIN_POINTS_AUTO_INSURANCE]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
  },
};

export const AUTO_INSURANCE_SURVEY_QUESTIONS = {
  skipped: false,
  completed: false,
  GENERAL_AUTO_INSURANCE_QUESTIONS,
};

export const FIRST_TIME_HOME_BUYER = 'Are you a first time home buyer?';

export const PROPERTY_TYPE_CASE = 'What type of home are you most interested in?';

export const OCCUPANCY_USE_CASE = 'What would be the occupancy type?';

export const MOST_IMPORTANT_ASPECTS_OF_HOME_PURCHASING =
  'What is/are the most important aspect(s) of home purchasing?';

export const HOME_PRICE_RANGE = 'What is the price range of your next home?';

export const PRIMARY = 'Primary';
export const SECONDARY = 'Secondary';
export const INVESTMENT = 'Investment';

export const SCHOOLS = 'Schools';
export const DIVERSITY = 'Diversity';
export const SAFETY = 'Safety';
export const TRANSPORTATION = 'Transportation';
export const TOURISTS = 'Tourists';

export const UNIVERSITIES = 'Universities';

export const OPEN_TO_RELOCATE_TO_AFFORD =
  'Are you open to relocate to another city or state to purchase a home?';

export const NEWLY_BUILT_OR_OLDER_HOME = 'Do you prefer a newly built home or an older home?';

export const CONSIDER_FIXER_UPPER = 'Would you consider buying a fixer-upper?';

export const BUNDLE_MORTGAGE_HOME_INSURANCE =
  'Would you prefer to bundle mortgages and homeowners insurance?';

export const CHANGES_IN_HOME_BUYING_LANDSCAPE =
  'Over the years, what have you noticed to be the biggest change in the home buying experience?';

export const BIGGEST_PAIN_POINT_HOME_BUYING =
  'What are the biggest problems you run into when shopping for a home?';

export const SINGLE_FAMILY = 'Single Family';
export const CONDO = 'Condo';
export const MULTI_FAMILY = 'Multi Family';

export const NEWLY_BUILT = 'Newly Built';

export const OLDER_HOME = 'Older Home';

export const NO_PREFERENCE = 'No Preference';

export const GENERAL_HOME_SURVEY_QUESTIONS = {
  [QUESTIONS]: {
    [FIRST_TIME_HOME_BUYER]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: YES,
          value: YES,
        },
        B: {
          text: NO,
          value: NO,
        },
        C: {
          text: NOT_SURE,
          value: NOT_SURE,
        },
      },
    },
    [PROPERTY_TYPE_CASE]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: SINGLE_FAMILY,
          value: SINGLE_FAMILY,
        },
        B: {
          text: CONDO,
          value: CONDO,
        },
        C: {
          text: MULTI_FAMILY,
          value: MULTI_FAMILY,
        },
        D: {
          text: MOBILE,
          value: MOBILE,
        },
        E: {
          text: NOT_SURE,
          value: NOT_SURE,
        },
      },
    },
    [OCCUPANCY_USE_CASE]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: PRIMARY,
          value: PRIMARY,
        },
        B: {
          text: SECONDARY,
          value: SECONDARY,
        },
        C: {
          text: INVESTMENT,
          value: INVESTMENT,
        },
        D: {
          text: NOT_SURE,
          value: NOT_SURE,
        },
      },
    },
    [MOST_IMPORTANT_ASPECTS_OF_HOME_PURCHASING]: {
      [TYPE]: MULTI_SELECT,
      [SELECTIONS]: {
        A: {
          text: SCHOOLS,
          value: SCHOOLS,
        },
        B: {
          text: DIVERSITY,
          value: DIVERSITY,
        },
        C: {
          text: SAFETY,
          value: SAFETY,
        },
        D: {
          text: TRANSPORTATION,
          value: TRANSPORTATION,
        },
        E: {
          text: TOURISTS,
          value: TOURISTS,
        },
        F: {
          text: UNIVERSITIES,
          value: UNIVERSITIES,
        },
      },
    },
    [HOME_PRICE_RANGE]: {
      [TYPE]: MULTI_SELECT,
      [SELECTIONS]: {
        A: {
          text: '< $200,000',
          value: 200000,
        },
        B: {
          text: '< $500,000',
          value: 500000,
        },
        C: {
          text: '< $750,000',
          value: 750000,
        },
        D: {
          text: '< $900,000',
          value: 900000,
        },
        E: {
          text: '> $900,000',
          value: 1000000,
        },
      },
    },
    [OPEN_TO_RELOCATE_TO_AFFORD]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: YES,
          value: YES,
        },
        B: {
          text: NO,
          value: NO,
        },
        C: {
          text: MAYBE,
          value: MAYBE,
        },
      },
    },
    [NEWLY_BUILT_OR_OLDER_HOME]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: NEWLY_BUILT,
          value: NEWLY_BUILT,
        },
        B: {
          text: OLDER_HOME,
          value: OLDER_HOME,
        },
        C: {
          text: DEPENDS,
          value: DEPENDS,
        },
        D: {
          text: NO_PREFERENCE,
          value: NO_PREFERENCE,
        },
      },
    },
    [CONSIDER_FIXER_UPPER]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: YES,
          value: YES,
        },
        B: {
          text: NO,
          value: NO,
        },
        C: {
          text: MAYBE,
          value: MAYBE,
        },
      },
    },
    [BUNDLE_MORTGAGE_HOME_INSURANCE]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: YES,
          value: YES,
        },
        B: {
          text: NO,
          value: NO,
        },
        C: {
          text: MAYBE,
          value: MAYBE,
        },
      },
    },
    [CHANGES_IN_HOME_BUYING_LANDSCAPE]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [BIGGEST_PAIN_POINT_HOME_BUYING]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
  },
};

export const HOME_SURVEY_QUESTIONS = {
  skipped: false,
  completed: false,
  GENERAL_HOME_SURVEY_QUESTIONS,
};

export const REFINANCE_MORTGAGE_FOR_OTHER_ASSETS =
  'Do you intend to ever refinance or take home equity to purchase other assets?';

export const MORTGAGE_LOAN_TYPES = 'Which mortgage loan(s) type best suites your needs?';

export const IMPACT_ON_MORTGAGES = 'How much does the mortgage loans impact the home you purchase?';

export const IDEAL_MONTHLY_PAYMENT = 'What is your ideal monthly payment?';

export const INHERIT_GIFT_HOME = 'Have you ever inherited a home?';

export const FIXED_RATE = 'Fixed-Rate';

export const FHA_LOANS = 'FHA Loans';

export const VA_LOANS = 'VA Loans';

export const JUMBO = 'Jumbo';

export const ARM = 'ARM';

export const USDA = 'USDA';

export const SPOKEN_MORTGAGE_OFFICER = 'Have you spoken to a mortgage officer or a broker?';

export const PREFERRED_MORTGAGE_REPAYMENT = 'What is your preferred mortgage repayment method?';

export const RESOURCES_AVAILABLE_FOR_MORTGAGES =
  'What resources do you wish are available to help you shop for mortgages?';

export const BIGGEST_PROBLEMS_MORTGAGES =
  'What are the biggest problems you encountered when you shop for mortgages?';

export const WEEKLY = 'Weekly';
export const FORTNIGHTLY = 'Fortnightly';

export const LUMP_SUM = 'Lump Sum';
export const AWHILE_AGO = 'Awhile Ago';
export const RECENTLY = 'Recently';

export const GENERAL_MORTGAGE_SURVEY_QUESTIONS = {
  [QUESTIONS]: {
    [REFINANCE_MORTGAGE_FOR_OTHER_ASSETS]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          value: YES,
          text: YES,
        },
        B: {
          value: NO,
          text: NO,
        },
        C: {
          value: MAYBE,
          text: MAYBE,
        },
      },
    },
    [MORTGAGE_LOAN_TYPES]: {
      [TYPE]: MULTI_SELECT,
      [SELECTIONS]: {
        A: {
          value: FIXED_RATE,
          text: FIXED_RATE,
        },
        B: {
          value: FHA_LOANS,
          text: FHA_LOANS,
        },
        C: {
          value: VA_LOANS,
          text: VA_LOANS,
        },
        D: {
          value: JUMBO,
          text: JUMBO,
        },
        E: {
          value: ARM,
          text: ARM,
        },
        F: {
          value: USDA,
          text: USDA,
        },
      },
    },
    [IMPACT_ON_MORTGAGES]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          value: '0%',
          text: '0%',
        },
        B: {
          value: '25%',
          text: '25%',
        },
        C: {
          value: '50%',
          text: '50%',
        },
        D: {
          value: '75%',
          text: '75%',
        },
        E: {
          value: '100%',
          text: '100%',
        },
      },
    },
    [IDEAL_MONTHLY_PAYMENT]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          value: '< $1500',
          text: '< $1500',
        },
        B: {
          value: '< $2500',
          text: '< $2500',
        },
        C: {
          value: '< $4000',
          text: '< $4000',
        },
        D: {
          value: '< $5000',
          text: '< $5000',
        },
        E: {
          value: '> $5000',
          text: '> $5000',
        },
      },
    },
    [PREFERRED_MORTGAGE_REPAYMENT]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: WEEKLY,
          value: WEEKLY,
        },
        B: {
          text: FORTNIGHTLY,
          value: FORTNIGHTLY,
        },
        C: {
          text: MONTHLY,
          value: MONTHLY,
        },
        D: {
          text: LUMP_SUM,
          value: LUMP_SUM,
        },
        E: {
          text: DEPENDS,
          value: DEPENDS,
        },
      },
    },
    [SPOKEN_MORTGAGE_OFFICER]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: AWHILE_AGO,
          value: AWHILE_AGO,
        },
        B: {
          text: RECENTLY,
          value: RECENTLY,
        },
        C: {
          text: NO,
          value: NO,
        },
      },
    },
    [RESOURCES_AVAILABLE_FOR_MORTGAGES]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [BIGGEST_PROBLEMS_MORTGAGES]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
  },
};

export const HOME_MORTGAGE_SURVEY_QUESTIONS = {
  skipped: false,
  completed: false,
  GENERAL_MORTGAGE_SURVEY_QUESTIONS,
};

export const CHECK_ALL_IMPORTANT_OF_HOMEOWNERS_INSURANCE =
  'When purchasing or shopping for Homeowners Insurance, check all that are essential.';

export const SWITCH_HOME_OWNERS_INSURANCE = "How often do you switch Homeowner's insurance?";

export const PREFERRED_PAYMENT_METHOD = 'What is your most preferred payment method?';

export const UMBRELLA_POLICY = 'Do you have an Umbrella Policy?';

export const PREMIUMS = 'Premiums';

export const COVERAGE = 'Coverage';

export const EASY_SWITCH = 'Easy Switch';

export const SERVICE = 'Service';

export const INSPECTION = 'Inspection';

export const MAIL = 'Mail';

export const IN_FUTURE = 'In Future';

export const IN_PAST = 'In Past';

export const RESOURCES_MISSING_FOR_HOMEOWNERS_INSURANCE =
  "What are some resources that would really help you with the homeowner's insurance shopping experience?";

export const BIGGEST_PAIN_POINTS_WITH_HOMEOWNERS_INSURANCE =
  "What are some of the biggest problems you encounter when shopping for homeowner's insurance?";

export const BIGGEST_PAIN_POINTS_WITH_CLAIMS_INSURANCE_HOME =
  'What are some of the biggest issues you run into with the claims experience?';

export const GENERAL_HOME_INSURANCE_SURVEY_QUESTIONS = {
  [QUESTIONS]: {
    [CHECK_ALL_IMPORTANT_OF_HOMEOWNERS_INSURANCE]: {
      [TYPE]: MULTI_SELECT,
      [SELECTIONS]: {
        A: {
          text: PREMIUMS,
          value: PREMIUMS,
        },
        B: {
          text: COVERAGE,
          value: COVERAGE,
        },
        C: {
          text: EASY_SWITCH,
          value: EASY_SWITCH,
        },
        D: {
          text: SERVICE,
          value: SERVICE,
        },
        E: {
          text: INSPECTION,
          value: INSPECTION,
        },
      },
    },
    [SWITCH_HOME_OWNERS_INSURANCE]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: NEVER,
          value: NEVER,
        },
        B: {
          text: SOMETIMES,
          value: SOMETIMES,
        },
        C: {
          text: FREQUENTLY,
          value: FREQUENTLY,
        },
        D: {
          text: NA,
          value: NA,
        },
      },
    },
    [PREFERRED_PAYMENT_METHOD]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: ONLINE,
          value: ONLINE,
        },
        B: {
          text: IN_PERSON,
          value: IN_PERSON,
        },
        C: {
          text: MAIL,
          value: MAIL,
        },
        D: {
          text: NA,
          value: NA,
        },
      },
    },
    [UMBRELLA_POLICY]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: YES,
          value: YES,
        },
        B: {
          text: NO,
          value: NO,
        },
        C: {
          text: IN_FUTURE,
          value: IN_FUTURE,
        },
        D: {
          text: IN_PAST,
          value: IN_PAST,
        },
      },
    },
    [RESOURCES_MISSING_FOR_HOMEOWNERS_INSURANCE]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [BIGGEST_PAIN_POINTS_WITH_HOMEOWNERS_INSURANCE]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [BIGGEST_PAIN_POINTS_WITH_CLAIMS_INSURANCE_HOME]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
  },
};

export const HOME_INSURANCE_SURVEY_QUESTIONS = {
  skipped: false,
  completed: false,
  GENERAL_HOME_INSURANCE_SURVEY_QUESTIONS,
};

export const CURRENTLY_A_MEMBER_OF_FCU = 'Are you currently a member of any Federal Credit Unions?';

export const WHICH_FCUs = 'Which Federal Credit Unions?';

export const HOW_DID_YOU_QUALIFY = 'How did you qualify to be a member?';

export const LIVE_IN_GEOGRAPHIC_AREA = 'Live in area';

export const WORSHIP_IN_GEOGRAPHIC_AREA = 'Worship in area';

export const WORK_IN_GEOGRAPHIC_AREA = 'Work in area';

export const SELECT_EMPLOYER_PROGRAMS = 'Select Employer Groups';

export const IMMEDIATE_FAMILY_MEMBER = 'Immediate Family Member';

export const HAVE_YOU_EVER_COMPARED_AUTO_LOAN_OFFERS =
  'Have you ever compared any auto loan offers from a Federal Credit Union to a large bank institution?';

export const HOW_MUCH_INTEREST_RATE_SAVED_HOW_MUCH_TOTAL_SAVINGS_AUTO_LOAN =
  'How much interest rate did you save? How much total savings over the lifetime of the auto loan?';

export const HAVE_YOU_EVER_COMPARED_MORTGAGE_LOAN_OFFERS =
  'Have you ever compared any mortgage loan offers from a Federal Credit Union to a large bank institution?';

export const HOW_MUCH_INTEREST_RATE_SAVED_HOW_MUCH_TOTAL_SAVINGS_MORTGAGE_LOAN =
  'How much interest rate did you save? How much total savings over the lifetime of the mortgage loan?';

export const WHAT_ARE_THE_CURRENT_QUALIFICATION_REQUIREMENTS_FOR_GPO_FCU =
  'What are the current qualification requirements to be a member at GPO Federal Credit Union?';

export const WHAT_ARE_THE_CURRENT_QUALIFICATION_REQUIREMENTS_FOR_SUMMIT_FCU =
  'What are the current qualification requirements to be a member at Summit Federal Credit Union?';

export const WHAT_ARE_THE_CURRENT_QUALIFICATION_REQUIREMENTS_FOR_BROADVIEW_FCU =
  'What are the current qualification requirements to be a member at Broadview Federal Credit Union?';

export const WHAT_ARE_THE_CURRENT_QUALIFICATION_REQUIREMENTS_FOR_QUORUM_FCU =
  'What are the current qualification requirements to be a member at Quorum Federal Credit Union?';

export const WHICH_FCU_DO_YOU_QUALIFY_FOR =
  'Which Federal Credit Union(s) do you qualify for? Are you able to find one you do qualify for if none of the above?';

export const GENERAL_FEDERAL_CREDIT_UNION_SURVEY_QUESTIONS = {
  [QUESTIONS]: {
    [CURRENTLY_A_MEMBER_OF_FCU]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: YES,
          value: YES,
        },
        B: {
          text: NO,
          value: NO,
        },
        C: {
          text: IN_PAST,
          value: IN_PAST,
        },
        D: {
          text: NA,
          value: NA,
        },
      },
    },
    [WHICH_FCUs]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [HOW_DID_YOU_QUALIFY]: {
      [TYPE]: MULTI_SELECT,
      [SELECTIONS]: {
        A: {
          text: LIVE_IN_GEOGRAPHIC_AREA,
          value: LIVE_IN_GEOGRAPHIC_AREA,
        },
        B: {
          text: WORSHIP_IN_GEOGRAPHIC_AREA,
          value: WORSHIP_IN_GEOGRAPHIC_AREA,
        },
        C: {
          text: WORK_IN_GEOGRAPHIC_AREA,
          value: WORK_IN_GEOGRAPHIC_AREA,
        },
        D: {
          text: SELECT_EMPLOYER_PROGRAMS,
          value: SELECT_EMPLOYER_PROGRAMS,
        },
        E: {
          text: IMMEDIATE_FAMILY_MEMBER,
          value: IMMEDIATE_FAMILY_MEMBER,
        },
        F: {
          text: NA,
          value: NA,
        },
      },
    },
    [HAVE_YOU_EVER_COMPARED_AUTO_LOAN_OFFERS]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: YES,
          value: YES,
        },
        B: {
          text: NO,
          value: NO,
        },
        C: {
          text: NA,
          value: NA,
        },
      },
    },
    [HOW_MUCH_INTEREST_RATE_SAVED_HOW_MUCH_TOTAL_SAVINGS_AUTO_LOAN]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [HAVE_YOU_EVER_COMPARED_MORTGAGE_LOAN_OFFERS]: {
      [TYPE]: SINGLE_SELECT,
      [SELECTIONS]: {
        A: {
          text: YES,
          value: YES,
        },
        B: {
          text: NO,
          value: NO,
        },
        C: {
          text: NA,
          value: NA,
        },
      },
    },
    [HOW_MUCH_INTEREST_RATE_SAVED_HOW_MUCH_TOTAL_SAVINGS_MORTGAGE_LOAN]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [WHAT_ARE_THE_CURRENT_QUALIFICATION_REQUIREMENTS_FOR_GPO_FCU]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [WHAT_ARE_THE_CURRENT_QUALIFICATION_REQUIREMENTS_FOR_SUMMIT_FCU]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [WHAT_ARE_THE_CURRENT_QUALIFICATION_REQUIREMENTS_FOR_BROADVIEW_FCU]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [WHAT_ARE_THE_CURRENT_QUALIFICATION_REQUIREMENTS_FOR_QUORUM_FCU]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [WHICH_FCU_DO_YOU_QUALIFY_FOR]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
  },
};

export const FEDERAL_CREDIT_UNION_SURVEY_QUESTIONS = {
  skipped: false,
  completed: false,
  GENERAL_FEDERAL_CREDIT_UNION_SURVEY_QUESTIONS,
};

export const WHAT_WAS_THE_MAKE_MODEL_YEAR_VEHICLE_SELECTED =
  'What was the Make, Model and Year of the vehicle selected?';

export const WHICH_OF_THE_LENDERS_DID_YOU_CHECK_THEIR_SITE_FOR_RATES_AFTER =
  'Which of the Lenders did you check their site for rates after?';

export const WHAT_WAS_THE_MILEAGE = 'What was the Mileage?';

export const WHAT_WERE_THE_LOAN_TERMS = 'What was / were the Loan Term(s) selected?';

export const WHAT_ESTIMATED_VALUE_OF_VEHICLE = 'What was the Estimated Value of the vehicle?';

export const WHAT_WAS_THE_DOWN_PAYMENT_OF_VEH = 'What was the Down Payment of the vehicle?';

export const WHAT_WAS_THE_CREDIT_TIER_SELECTED = 'What was the Credit Tier selected?';

export const WHAT_WAS_RATE_DIFFERENCE_WHEN_YOU_CHECKED =
  "When you checked the Lenders' Platform, what was the rate difference?";

export const GENERAL_AUTO_RATES_FILTER_SURVEY_QUESTIONS = {
  [QUESTIONS]: {
    [WHAT_WAS_THE_MAKE_MODEL_YEAR_VEHICLE_SELECTED]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [WHICH_OF_THE_LENDERS_DID_YOU_CHECK_THEIR_SITE_FOR_RATES_AFTER]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [WHAT_WAS_THE_MILEAGE]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [WHAT_WERE_THE_LOAN_TERMS]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [WHAT_ESTIMATED_VALUE_OF_VEHICLE]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [WHAT_WAS_THE_DOWN_PAYMENT_OF_VEH]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [WHAT_WAS_THE_CREDIT_TIER_SELECTED]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [WHAT_WAS_RATE_DIFFERENCE_WHEN_YOU_CHECKED]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
  },
};

export const AUTO_RATES_FILTER_SURVEY_QUESTIONS = {
  skipped: false,
  completed: false,
  GENERAL_AUTO_RATES_FILTER_SURVEY_QUESTIONS,
};

export const WHAT_WAS_THE_PROPERTY_TYPE_SELECTED = 'What was the Property Type selected?';

export const WHAT_WAS_THE_OCCUPANCY_TYPE_SELECTED = 'What was the Occupancy Type selected?';

export const WHAT_WAS_MORTGAGE_TERM_SELECTED = 'What was / were the Loan Term(s) selected?';

export const WHAT_WAS_THE_DOWN_PAYMENT = 'What was the Down Payment?';

export const WHAT_WAS_ESTIMATE_VALUE = 'What was the Estimated Value?';

export const GENERAL_MORTGAGE_RATES_FILTER_SURVEY_QUESTIONS = {
  [QUESTIONS]: {
    [WHAT_WAS_THE_PROPERTY_TYPE_SELECTED]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [WHAT_WAS_THE_OCCUPANCY_TYPE_SELECTED]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [WHAT_WAS_MORTGAGE_TERM_SELECTED]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [WHAT_WAS_THE_DOWN_PAYMENT]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [WHAT_WAS_ESTIMATE_VALUE]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [WHAT_WAS_THE_CREDIT_TIER_SELECTED]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [WHICH_OF_THE_LENDERS_DID_YOU_CHECK_THEIR_SITE_FOR_RATES_AFTER]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
    [WHAT_WAS_RATE_DIFFERENCE_WHEN_YOU_CHECKED]: {
      [TYPE]: OPEN_ENDED_INPUT,
    },
  },
};

export const MORTGAGE_RATES_FILTER_SURVEY_QUESTIONS = {
  skipped: false,
  completed: false,
  GENERAL_MORTGAGE_RATES_FILTER_SURVEY_QUESTIONS,
};

export const GENERAL_QUESTIONS_TITLE = 'General Questions';
export const UI_EXPERIENCE_TITLE = 'UI Experience';
export const AUTO_SURVEY_QUESTIONS_TITLE = 'Auto Survey';
export const AUTO_LOANS_SURVEY_QUESTIONS_TITLE = 'Auto Loan';
export const AUTO_INSURANCE_SURVEY_QUESTIONS_TITLE = 'Auto Insurance';
export const HOME_SURVEY_QUESTIONS_TITLE = 'Home Survey';
export const HOME_MORTGAGE_SURVEY_QUESTIONS_TITLE = 'Home Mortgage';
export const HOME_INSURANCE_SURVEY_QUESTIONS_TITLE = 'Home Insurance';

export const FEDERAL_CREDIT_UNION = 'Federal Credit Union';
export const AUTO_RATES_FILTER = 'Auto Rates Filter';
export const MORTGAGE_RATES_FILTER = 'Mortgage Rates Filter';

export const ALL_SURVEY_QUESTIONS = {
  [GENERAL_QUESTIONS_TITLE]: GENERAL_QUESTIONS,
  [UI_EXPERIENCE_TITLE]: UI_EXPERIENCE_QUESTIONS,
  [AUTO_SURVEY_QUESTIONS_TITLE]: AUTO_SURVEY_QUESTIONS,
  [AUTO_LOANS_SURVEY_QUESTIONS_TITLE]: AUTO_LOANS_SURVEY_QUESTIONS,
  [AUTO_INSURANCE_SURVEY_QUESTIONS_TITLE]: AUTO_INSURANCE_SURVEY_QUESTIONS,
  [HOME_SURVEY_QUESTIONS_TITLE]: HOME_SURVEY_QUESTIONS,
  [HOME_MORTGAGE_SURVEY_QUESTIONS_TITLE]: HOME_MORTGAGE_SURVEY_QUESTIONS,
  [HOME_INSURANCE_SURVEY_QUESTIONS_TITLE]: HOME_INSURANCE_SURVEY_QUESTIONS,
  [FEDERAL_CREDIT_UNION]: FEDERAL_CREDIT_UNION_SURVEY_QUESTIONS,
  [AUTO_RATES_FILTER]: AUTO_RATES_FILTER_SURVEY_QUESTIONS, // specifcs to get them to enter the make and models that they entered
  [MORTGAGE_RATES_FILTER]: MORTGAGE_RATES_FILTER_SURVEY_QUESTIONS, // specifics to get the mortgage
  Referral: '', // Who referred them over, and how many people they referred?
};

export const BACK = 'Back';
export const SKIP = 'Skip';
export const SUBMIT = 'Submit';
export const CONTINUE = 'Continue';

export const SIGN_UP_AND_GET_REWARDED = 'Sign Up And Get Rewarded!';
export const GET_REWARDED = 'Redeem';
export const COMPLETE_SURVEY_AND_GET_REWARDED = 'Earn Your Gift Card!';
export const EMAIL_ON_FILE = 'Email On File';

export const MODAL_BUTTON_TITLE = 'MODAL_BUTTON_TITLE';
export const MODAL_BUTTON_ICON = 'MODAL_BUTTON_ICON';
export const MODAL_BUTTON_ID = 'MODAL_BUTTON_ID';

export const SIGNED_IN_MODAL_ON_SURVEY = {
  [false]: () => ({
    [MODAL_BUTTON_TITLE]: GET_REWARDED,
    [MODAL_BUTTON_ICON]: <RedeemIcon sx={{ mr: 2 }} />,
    [MODAL_BUTTON_ID]: 'survey-sign-up-button',
  }),
  [true]: () => ({
    [MODAL_BUTTON_TITLE]: EMAIL_ON_FILE,
    [MODAL_BUTTON_ICON]: <DomainVerificationIcon sx={{ mr: 2 }} />,
    [MODAL_BUTTON_ID]: 'info-verified-button',
  }),
};
export const TOASTER_HEADER = 'We would love your feedback!';
export const WIN_GIFT_CARD = 'Complete our survey for a chance to win a $35 gift card';
export const COMPLETE_SURVEY = 'Complete Survey';

export const RATES_EMAIL_SUBMITTED_TEXT = 'Rates have been sent. Please check your email.';

export const SIGN_UP_ERROR_TEXT = 'There was an error sending rates. Please try again.';
